import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-headboy',
  templateUrl: './headboy.component.html',
  styleUrls: ['./headboy.component.css']
})
export class HeadboyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
